const SocialItem = ({ socialLink, socialIcon }) => {
	return (
		<a href={socialLink} target='_blank' className='socialIcon'>
			<i className={socialIcon}></i>
		</a>
	);
};

export default SocialItem;
